<template>
  <div class="text-left" data-testid="upload-quality-warnings-step">
    <div class="border border-alert bg-orange-50 rounded-lg px-4 py-3">
      <p class="text-md font-bold text-textPrimary m-0" data-testid="upload-quality-warnings-title">
        {{ qualityWarningsTitle(messages.length) }}
      </p>
      <ul class="list-disc pl-5 mt-2 mb-0 text-sm text-textPrimary">
        <li v-for="(message, index) in messages" :key="index" data-testid="upload-quality-warning">
          {{ message }}
        </li>
      </ul>
    </div>

    <!--
      #3083 — ANTES do envio (pré-checagem) nada foi gravado: "Refazer a foto" troca o arquivo
      de verdade. DEPOIS do envio o registro já tem folha e um novo envio cairia no 409, então o
      painel só informa e diz quem pode trocar a folha.
    -->
    <p class="text-xs text-neutral50 mt-3" data-testid="upload-quality-warnings-hint">
      {{ hint }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { qualityWarningsTitle, translateQualityWarnings } from './quality-warnings'

/**
 * Eixo 2B — painel de avisos de qualidade da imagem. Nunca bloqueia: sem `warnings` o
 * componente não é montado pelo modal.
 */

const props = withDefaults(
  defineProps<{ warnings: string[]; phase?: 'BEFORE_SEND' | 'AFTER_SEND' }>(),
  { phase: 'BEFORE_SEND' }
)

const messages = computed(() => translateQualityWarnings(props.warnings))

const hint = computed(() =>
  props.phase === 'BEFORE_SEND'
    ? 'A folha ainda não foi enviada. "Refazer a foto" volta ao passo do arquivo para escolher uma imagem melhor; "Continuar assim mesmo" segue com esta.'
    : 'O registro já foi enviado com esta folha. Para trocá-la, a Auditoria precisa reprovar o registro pedindo uma nova folha.'
)
</script>
